import React from "react";
import { Redirect } from "react-router-dom";
import config from "../../../config";
const Outside = props => {
  return <Redirect to={config.SIGNUP.APP_PATH + "/s/autolocation"} />;
};

export default Outside;
